export enum SitemonitoringCheckedUrlsDateStatus {
  ALL = "0",
  WITH_CHANGES = "1",
  WITHOUT_CHANGES = "2",
}

export const PAG_CURSOR_END = "i9qfuw987234jakjzxcvlkjoqwieru23";
